<div class="chat-input-container">
  <mat-form-field appearance="outline" class="chat-input-field">
    <mat-label>Ask a question...</mat-label>
    <textarea 
      matInput
      #textareaEl
      [(ngModel)]="messageText"
      [disabled]="disabled"
      (keypress)="onKeyPress($event)"
      placeholder="e.g., What is the modernization readiness score for this app?"
      rows="2"
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="6">
    </textarea>
    @if (!disabled) {
<mat-hint>Press Enter to send, Shift+Enter for new line</mat-hint>
}
    @if (disabled) {
<mat-hint>Waiting for response...</mat-hint>
}
  </mat-form-field>

  <button 
    mat-fab
    color="primary"
    [disabled]="!messageText.trim() || disabled"
    (click)="sendMessage()"
    class="send-button"
    matTooltip="Send message">
    <mat-icon>send</mat-icon>
  </button>
</div>
